import { Card, Row } from "antd";
import { Loader } from "./Loader";
import PieChartCard from "./PieChartCard";
import { OpenedAccountsTooltip } from "./OpenedAccountsTooltip";

type PieChartContainerProps = {
  header: string;
  isLoading: boolean;
  data: any;
  colors: string[];
  source: 1 | 2;
  showTooltip?: boolean;
};

export const PieChartContainer = ({
  header,
  isLoading,
  data,
  colors,
  source,
  showTooltip,
}: PieChartContainerProps) => {
  return (
    <Card className="dashboard-card top">
      <Row className="mb-2 justify-space-between align-center">
        <p className="text my-0">{header}</p>
        {showTooltip && <OpenedAccountsTooltip />}
      </Row>
      {!isLoading ? (
        <PieChartCard data={data} colors={colors} source={source} />
      ) : (
        <Loader />
      )}
    </Card>
  );
};
